/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { INodeProps,Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDobbiesTopPicksCarouselViewProps,ITilesViewProps } from './dobbies-top-picks-carousel';

const DobbiesTopPicksCarouselView:React.FC<IDobbiesTopPicksCarouselViewProps>=props => {
    const { heading, tiles, SingleSlideCarouselComponentProps, GridComponentProps, isCarousel,TileCollectionContainer } = props;
    if (tiles) {
        return (
            <div className='container'>
                <Module {...TileCollectionContainer}>
                    {heading}
                    {
                        isCarousel ? _renderCarousel(SingleSlideCarouselComponentProps, tiles) : _renderGrid(GridComponentProps, tiles)
                    }
                </Module>
            </div>
        );
    }
    props.context.telemetry.error('Tiles Collection is empty, module wont render.');
    return null;
};

const _renderCarousel = (carouselContainer: INodeProps, items: ITilesViewProps[]): JSX.Element => {
    return (
        <Node {...carouselContainer}>
            {items && items.map(_renderTile)}
        </Node>
    );
};

const _renderGrid = (gridContainer: INodeProps, items: ITilesViewProps[]): JSX.Element => {
    return (
     <Node {...gridContainer}>
            {items && items.map(_renderTile)}
        </Node>
    );
};

const _renderTile = (tile: ITilesViewProps): JSX.Element => {
    const {  TileContainer,Tile } = tile;

    return (
      <Node  {...TileContainer}>
          {Tile}
    </Node>
    );
};
export default DobbiesTopPicksCarouselView;